// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { emojiPlugin, EmojiNodeDataProvider } from '@atlaskit/editor-plugin-emoji';
export type {
	EmojiPlugin,
	EmojiPluginOptions,
	EmojiPluginState,
	EmojiPluginSharedState,
	EmojiPluginDependencies,
	EmojiPluginActions,
	EmojiPluginCommands,
} from '@atlaskit/editor-plugin-emoji';
